import React, { type JSX } from 'react';

import { FormProps } from '../../types';

const findName = (children: JSX.Element): string => {
	const child = React.Children.only(children);
	if (child.props.name) {
		return child.props.name;
	}
	return findName(child.props.children);
};

const InputWrapper = <FieldNames extends string>({
	showValidationBeforeBlur,
	children,
	formProps: { bindWithErrorProps },
}: {
	showValidationBeforeBlur?: boolean;
	children: JSX.Element;
	formProps: FormProps<FieldNames>;
}): React.FunctionComponentElement<unknown> => {
	const child = React.Children.only(children);
	const fieldName = (child.props.name || findName(child.props.children)) as FieldNames;
	return React.cloneElement(child, {
		...bindWithErrorProps(fieldName, child.props.type, showValidationBeforeBlur),
		...child.props,
	});
};

export default InputWrapper;
